import { FieldOptionsAsyncComboBoxCategories } from '../types/FieldOptionsAsyncComboBoxTypes'

export const FIELD_OPTIONS_ASYNC_CATEGORIES: Array<FieldOptionsAsyncComboBoxCategories> = [
   'MATCHED_AS_PER_YOUR_INPUT',
   'OTHER_OPTIONS'
]

export const NO_DATA_VIEW_CONTENT = '-'

export const DEFAULT_SKELETON_LOADER_DURATION_TIME = 1.5

//NOTE: Added this constant here to resolve circular dependency
export const PORTALS_TABLET_MIN_WIDTH = 600

export const NO_OF_OTP_BOXES = 6

export const RESEND_TIME_IN_SECONDS = 120

export const FIELD_FEE_AFFECTED_TOOL_TIP_ID = 'FEE_AFFECTED_TOOL_TIP_ID'

export const DATA_FIELD_FEE_AFFECTED_ATTRIBUTE = 'data-field-fee-affected-text'

export const DEFAULT_FORMULA_CELL_VALUE = '-'

export const FORMULA_COLUMNS_NAME_BRACES_REGEX = /[<>]/g

export const FORMULA_COLUMN_NAME_REGEX = /<<(.*?)>>/g

export const FIELDS_TABLE_FORMULA_CELL_REGEX = /^\s*(<<[^>]+>>|[(\w\s].*?)\s*([<>=!]+)\s*(<<[^>]+>>|\d+(?:\.\d+)?|\d+|[\w\s()+\-/*]+|'.*?'|".*?")\s*$/

export const MAX_PIPELINE_PICKER_OPTIONS = 15

export const DEFAULT_OTP_NUM_INPUTS = 6
